export default "./../../assets/images/RAP_BrisbaneRiverElement-01.png";